<header class="background-header classic-background"></header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}" *ngIf="accessList && accessList.requests && showAllUsers == true">
	<section class="container admin-dashboard-parent copy-editor-container">
		<section class="template-section-title">
			<div class="breadcrumb-container">
				<span>Admin <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Unlock Request'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
				<h1>Unlock Request</h1>
			</div>
		</section>
		<div class="notification-bubble-container">
            <app-notification-bubble></app-notification-bubble>
        </div>
		<!-- Table Data -->
		<section class="all-users-data">
			<div class="table-responsive admin-dashboard-table">
				<table class="table table-borderless table-hover">
					<thead>
						<tr>
							<th scope="col">Created At</th>
							<th scope="col">Request</th>
              <th scope="col">Response</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let dataUser of accessList.requests; let i = index;" (click)="onSelect(dataUser)">
							<td>{{dataUser.created_at | date}}</td>
							<td>{{dataUser.event}}</td>
              <td>{{dataUser.response ? (dataUser.response.data.granted? 'Unlocked' : 'Denied') : 'Pending' }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>
	</section>
</section>

<app-unlock-request-details *ngIf="userDetail == true" [dataUser]="selectedUser" (onClick)="backFromDetailUser()"
					 (userOutputValue)="displayUserData($event)"></app-unlock-request-details>
